const getChangedValues = (initialValues: any, currentValues: any, fieldsToKeep: string[] = []) => {
    const changedValues: any = {};

    // Iterate through keys of initialValues
    for (const key in initialValues) {
        if (initialValues.hasOwnProperty(key)) {
            const initialValue = initialValues[key];
            const currentValue = currentValues[key];

            // Always keep specified fields
            if (fieldsToKeep.includes(key)) {
                changedValues[key] = currentValue;
                continue;
            }

            // Compare top-level values
            if (initialValue !== currentValue) {
                changedValues[key] = currentValue;
            }
        }
    }

    // Add new keys from currentValues that are not in initialValues
    for (const key in currentValues) {
        if (currentValues.hasOwnProperty(key) && !initialValues.hasOwnProperty(key)) {
            changedValues[key] = currentValues[key];
        }
    }

    return changedValues;
};

export default getChangedValues;
